import * as React from "react";
import {
  List,
  DataTable,
  BooleanField,
  SearchInput,
  BooleanInput,
  EditButton,
  SelectArrayInput,
} from "react-admin";
import { getCountries } from "../enums/Countries";

const RegionFilter = [
  <SearchInput source="name" alwaysOn />,
  <SelectArrayInput label="País" source="country" choices={getCountries()} />,
  <BooleanInput label="Descuentos" source="hasDiscounts" />,
  <BooleanInput label="Visible" source="visible" />,
  <BooleanInput label="Activo" source="active" />,
];

const RegionList = () => {
  return (
    <List title="Regiones" filters={RegionFilter}>
      <DataTable rowClick="show" bulkActionButtons={false}>
        <DataTable.Col source="name" label="Nombre" />
        <DataTable.Col source="country" label="País" />
        <DataTable.Col source="hasDiscounts" label="Descuentos">
          <BooleanField source="hasDiscounts" label="Descuentos" />
        </DataTable.Col>
        <DataTable.NumberCol source="order" label="Orden" />
        <DataTable.Col source="visible" label="Visible">
          <BooleanField source="visible" label="Visible" />
        </DataTable.Col>
        <DataTable.Col source="active" label="Activo">
          <BooleanField source="active" label="Activo" />
        </DataTable.Col>
        <DataTable.Col>
          <EditButton />
        </DataTable.Col>
      </DataTable>
    </List>
  );
};

export default RegionList;
